import { render, staticRenderFns } from "./SelectCustomerGroups.vue?vue&type=template&id=205d22e4"
import script from "./SelectCustomerGroups.vue?vue&type=script&lang=js"
export * from "./SelectCustomerGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports